<template>
  <div class="game-room" ref="voiceRoomBox" id="voice-room">
    <div class="right">
      <div class="main" ref="voiceRoomMain">
        <game-room-main class="game-room-main"></game-room-main>
        <chat-vue class="chat-main"></chat-vue>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex';
import GameRoomMain from '@/components/GameRoom/game-room-main.vue';
import ChatVue from '@/components/GameRoom/chat.vue';
import mRtc from '@/components/VoiceRoom/mRtc';
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
import ChatProvider from '@/components/VoiceRoom/chatProvider';
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';
import { getToken, getRoomInfo, joinRoom, keepConnect } from '@/api/voice-room';
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
import GameRoomEventEmitter from '@/components/GameRoom/gameRoomEventBus';
import GameRoomEvent from '@/components/GameRoom/gameRoomEvent';
export default {
  name: 'VoiceRoom',
  components: {
    GameRoomMain,
    ChatVue
  },
  props: {},
  data() {
    return {
      VoiceRoomProvider,
      ChatProvider,
      CurrentUserProvider,
      VoiceRoomIM,
      mRtc,
      localVoiceRoomId: localStorage.getItem('voiceRoomId'),
      keepConnectLoading: false,
      keepConnectInterval: null,
      scale: 0
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path != '/') {
      window.open(to.fullPath, '_blank');
      next(false);
    } else {
      next(true);
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['userInfo', 'aliasList']),
    roomUid() {
      const { roomId } = this.$route.params;
      return roomId;
    },
    uuid() {
      return this.userInfo.uuid ? Number(this.userInfo.uuid) : null;
    },
    roomInfo() {
      return VoiceRoomProvider.roomInfo;
    }
  },
  methods: {
    async initData() {
      localStorage.setItem('voiceRoomId', '');
      this.localVoiceRoomId = this.roomUid;
      // 在一个标签页中
      window.onstorage = e => {
        console.log(e);
        if (e.key === 'voiceRoomId' && e.newValue !== this.localVoiceRoomId) {
          this.$router.replace('/');
        }
      };
      localStorage.setItem('voiceRoomId', this.roomUid);
      VoiceRoomEventEmitter.on(VoiceRoomEvent.OnAdminChange, () => {
        this.getUserAdmin();
      });
      VoiceRoomEventEmitter.on(VoiceRoomEvent.voiceRoomScale, scale => {
        this.scale = scale || 0;
        console.log('VoiceRoomEvent.voiceRoomScale', this.scale);
        this.setScale();
      });
      this.init();
      window.onresize = () => {
        this.setScale();
      };
    },
    /**
     * @description: 加入群聊
     * @return {*}
     */
    async joinGroup() {
      try {
        await VoiceRoomIM.joinGroup(this.roomUid);
      } catch (error) {
        this.$util.captureException(
          'game-room',
          { roomUid: this.roomUid, fun: 'joinGroup' },
          error
        );
      }
    },

    async init() {
      try {
        await CurrentUserProvider.setUserInfo(this.userInfo);
        await this.getUserAdmin();
        ChatProvider.init();
        await this.getRoomInfo();
        await this.initRtc();
        await this.initIm();
        await this.joinRoom();
        this.initGame();
        this.keepConnect();
      } catch (error) {
        if(error && error.msg) {
          this.$message.error(error.msg);
        } else {
          this.$message.error(error ? error : i18n.t('upgrade_page_views_game_room_index_2009'));
        }
        this.$util.captureException(
          'game-room',
          { roomUid: this.roomUid, fun: 'init' },
          error
        );
      }
    },
    initGame() {
      GameRoomEventEmitter.emit(GameRoomEvent.onInitGame);
    },
    async initIm() {
      try {
        // await VoiceRoomIM.login(this.userInfo);
        await VoiceRoomIM.IM_READY;
        await VoiceRoomIM.joinGroup(this.roomUid);
        await VoiceRoomIM.setUserId(this.uuid);
        console.log('initImSuccess');
        return true;
      } catch (error) {
        this.$util.captureException(
          'game-room',
          { roomUid: this.roomUid, fun: 'initIm' },
          error
        );
        throw new Error(i18n.t('upgrade_page_views_game_room_index_2010'));
      }
    },
    async initRtc() {
      try {
        const { data } = await getToken({ roomUid: this.roomUid });
        if (data) {
          this.subscribeAudio();
          await mRtc.join({
            appId: data.appId,
            channel: this.roomUid,
            token: data.token,
            uid: Number(this.uuid)
          });
          await mRtc.initTrack();
          await mRtc.ready();
          await mRtc.publish();
          return true;
        }
      } catch (error) {
        console.log(error);

        this.$util.captureException(
          'game-room',
          { roomUid: this.roomUid, fun: 'initRtc' },
          error
        );
        throw new Error(
          i18n.t('upgrade_page_views_game_room_index_2011')
        );
      }
    },

    async getRoomInfo() {
      try {
        const { data } = await getRoomInfo({ roomUid: this.roomUid });
        if (data) {
          VoiceRoomProvider.setRoomInfo(data);
          if (data.black) {
            throw new Error(i18n.t('upgrade_page_views_game_room_index_2012'));
          }
          if (data.createBy == this.uuid || CurrentUserProvider.isAdmin) {
            CurrentUserProvider.setCreate(data.createBy == this.uuid);
            return data;
          }
        } else {
          throw new Error(i18n.t('upgrade_page_views_game_room_index_2013'));
        }
      } catch (error) {
        this.$util.captureException(
          'game-room',
          { roomUid: this.roomUid, fun: 'getRoomInfo' },
          error
        );
        throw error;
      }
    },

    async joinRoom() {
      try {
        let params = {};
        params['roomUid'] = this.roomUid;
        params['action'] = 'JoinRoom';
        params['targetUuid'] = this.uuid;
        await joinRoom(params);
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 订阅音频
     * @return {*}
     */
    async subscribeAudio() {
      try {
        // 监听发布事件
        mRtc.client.on('user-published', async (user, mediaType) => {
          mRtc.subscribeRemoteUser(user, mediaType);
        });
        // 监听取消发布事件
        mRtc.client.on('user-unpublished', async user => {
          delete mRtc.remoteUsers[user.uid];
        });
      } catch (error) {
        console.log('subscribeAudio', error);
        this.$util.captureException(
          'game-room',
          { roomUid: this.roomUid, fun: 'subscribeAudio' },
          error
        );
      }
    },

    async leaveVoiceRoom() {
      try {
        if (this.keepConnectInterval) {
          clearInterval(this.keepConnectInterval);
          this.keepConnectInterval = null;
        }
        await mRtc.leave();
        VoiceRoomEventEmitter.removeAllListeners();
      } catch (error) {
        this.$util.captureException(
          'game-room',
          { roomUid: this.roomUid, fun: 'leaveVoiceRoom' },
          error
        );
        throw error;
      }
    },

    // 获取用户是否是管理员
    async getUserAdmin() {
      const adminList = await VoiceRoomProvider.getAdminList(this.roomUid);
      if (adminList && adminList.find(item => item.uuid == this.uuid)) {
        CurrentUserProvider.setAdmin(true);
      } else {
        CurrentUserProvider.setAdmin(false);
      }
      return;
    },
    setScale() {
      const height = this.$refs.voiceRoomBox.offsetHeight;
      const width = this.$refs.voiceRoomBox.offsetWidth;
      const childHeight = this.$refs.voiceRoomMain.offsetHeight + 20;
      const childWidth = this.$refs.voiceRoomMain.offsetWidth + 20;
      let scale = 1;
      if (childWidth > width || childHeight > height) {
        const widthSize = width / childWidth;
        const heightSize = height / childHeight;
        if (widthSize < heightSize) {
          scale = widthSize;
        } else {
          scale = heightSize;
        }
        scale = scale + this.scale / 100;
        this.$refs.voiceRoomMain.style.transform = `scale(${scale})`;
        this.$refs.voiceRoomMain.style.transformOrigin = `50% 50%`;
      } else {
        this.$refs.voiceRoomMain.style.transform = `scale(${1 +
          this.scale / 100})`;
        // this.$refs.voiceRoomMain.style.transformOrigin = `0 0`;
        this.$refs.voiceRoomMain.style.transformOrigin = `50% 50%`;
      }
      localStorage.setItem('voiceRoomScale', this.scale);
    },
    keepConnect() {
      this.keepConnectInterval = setInterval(async () => {
        try {
          if (this.keepConnectLoading) {
            return;
          } else {
            this.keepConnectLoading = true;
            await keepConnect({ roomUid: this.roomUid });
            this.keepConnectLoading = false;
          }
        } catch (error) {
          this.keepConnectLoading = false;
        }
      }, 30000);
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    this.scale = Number(localStorage.getItem('voiceRoomScale') || 0);
    this.setScale();
  },
  destroyed() {
    this.leaveVoiceRoom();
  }
};
</script>
<style lang="scss" scoped>
.game-room {
  font-family: Microsoft YaHei, PingFang TC, PingFang TC Medium, sans-serif;
  display: flex;
  align-items: center;
  width: 100% !important;
  overflow: auto;
  height: 100%;
  @include hideScrollBar(0, 0);
  position: relative;
  .right {
    flex: 1 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1px;
    @include hideScrollBar(0, 0);
  }
  .main {
    display: flex;
    align-items: stretch;
    height: 844px;
  }
  .chat-main {
    margin: 0 11px;
  }
  .game-room-main {
    margin: 0;
  }
  .room-info {
    flex: none;
  }
  .user-list {
    flex: auto;
  }
}
</style>
